import { MODAL_TYPES } from 'ContentEditorUI/lib/modalConstants';
export const KB_MODAL_TYPES = Object.assign({}, MODAL_TYPES, {
  CREATE_CATEGORY_MODAL: 'CREATE_CATEGORY_MODAL',
  CREATE_SUB_CATEGORY_MODAL: 'SUB_CATEGORY_MODAL',
  EDIT_CATEGORY_MODAL: 'EDIT_CATEGORY_MODAL',
  EDIT_SUB_CATEGORY_MODAL: 'EDIT_SUB_CATEGORY_MODAL'
});